/**
 * Stage Types
 *
 * What stage of deployment is this? Dev, staging, or prod?
 */
export const AWS_STAGE_TYPE = {
  /**
   * Development environment, typically used for testing and development.
   */
  DEV: "dev",

  /**
   * Staging environment, used for pre-production testing.
   */
  STAGE: "stage",

  /**
   * Production environment, used for live deployments.
   */
  PROD: "prod",
} as const;

/**
 * Above const as a type.
 */
export type AwsStageType = (typeof AWS_STAGE_TYPE)[keyof typeof AWS_STAGE_TYPE];

/**
 * Deployment target role: whether an (account, region) is the primary or
 * secondary deployment target (e.g. primary vs replica region).
 */
export const DEPLOYMENT_TARGET_ROLE = {
  /**
   * Account and region that represents the primary region for this service.
   * For example, the base DynamoDB Region for global tables.
   */
  PRIMARY: "primary",
  /**
   * Account and region that represents a secondary region for this service.
   * For example, a replica region for a global DynamoDB table.
   */
  SECONDARY: "secondary",
} as const;

/**
 * Type for deployment target role values.
 */
export type DeploymentTargetRoleType =
  (typeof DEPLOYMENT_TARGET_ROLE)[keyof typeof DEPLOYMENT_TARGET_ROLE];

/**
 * Environment types (primary/secondary).
 *
 * @deprecated Use {@link DEPLOYMENT_TARGET_ROLE} instead. This constant is maintained for backward compatibility.
 */
export const AWS_ENVIRONMENT_TYPE = DEPLOYMENT_TARGET_ROLE;

/**
 * Type for environment type values.
 *
 * @deprecated Use {@link DeploymentTargetRoleType} instead. This type is maintained for backward compatibility.
 */
export type AwsEnvironmentType = DeploymentTargetRoleType;
